<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <el-tabs
      v-model="state.tabName"
      style="padding: 0 10px; margin-top: 10px"
      class="detail-tabs"
    >
      <el-tab-pane label="三方协议缴税" name="sfxy">
        <c_TaxPaySfxyList v-if="state.tabName == 'sfxy'"></c_TaxPaySfxyList>
      </el-tab-pane>
      <el-tab-pane label="银联缴税" name="yl">
        <c_TaxPayYlList v-if="state.tabName == 'yl'"></c_TaxPayYlList>
      </el-tab-pane>
    </el-tabs>
    <div
      style="
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 13px;
        color: #ffa500;
      "
    >
      1.申报数据更正或作废会影响缴款金额，请及时「从税局获取欠费信息」，以获取最新待缴数据。
      <br />
      2.如果进行了立即缴款操作，但未完成税款缴纳，该笔单据会被锁定。您可等待30分钟自动解锁后再重新发起缴款;或点击【作废电子税票号】进行作废后再发起缴款
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";

export default {
  setup() {
    const state = reactive({
      tabName: "sfxy",
    });
    onMounted(() => {});
    return {
      state,
    };
  },
};
</script>
<style scoped></style>
